import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpClient.service';
import { BehaviorSubject, Observable, filter,map } from 'rxjs';
import { appMasterApi } from '../../constants/app-master-const';
import { PaginationType } from '../../interfaces/pagination/pagination-type';
import { environment } from 'src/environments/environment';
import { specificUserParams, userParams } from '../../helpers/helperfunc';
import { PermissionsPipe } from '../../pipe/permissions.pipe';
import { permissionEntity } from '../../constants/permission';
import { HttpEvent, HttpResponse } from '@angular/common/http';
import { LocalStorageService } from '../localStorage/localStorage.service';

@Injectable({
    providedIn: 'root',
})
export class ApplicationMasterService {
    permissions_entity = permissionEntity;

    constructor(
        private httpClientService: HttpClientService,
        private _permissionPipe: PermissionsPipe, // dont remove this
        private _lc: LocalStorageService
    ) { }

    checkToggle = new BehaviorSubject<boolean>(false);
    checkToggle$ = this.checkToggle.asObservable();

    shouldReload = new BehaviorSubject<any>({ updated: false });
    shouldReload$ = this.shouldReload.asObservable();

    getApplicationData = new BehaviorSubject<any>(false);
    getApplicationData$ = this.getApplicationData.asObservable();

    getApplication(pagination: PaginationType, filters?: any, sort: { sortDataOption: string, sortDataOrder: string } = null): Observable<any> {
        let query = '?';
        if (filters) {
            query += filters;
        }
        if (sort) { ///? for sorting
            query += `sortDataOption=${sort?.sortDataOption}&sortDataOrder=${sort?.sortDataOrder}&`;
        }
        query += userParams.call(
            this,
            this.permissions_entity.modules.applications
        );
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;

        return this.httpClientService.get(
            `${appMasterApi.getApplication}${query}`
        );
    }

    getApplicationV2(pagination: PaginationType, filters?: any, sort: { sortDataOption: string, sortDataOrder: string } = null, archived?:boolean): Observable<any> {
        let query = '?';
        if (filters) {
            query += filters;
        }
        if (sort) { ///? for sorting
            query += `sortDataOption=${sort?.sortDataOption}&sortDataOrder=${sort?.sortDataOrder}&`;
        }
        if(archived){
            query+='archiveStatus=true&'
        }
        query += userParams.call(
            this,
            this.permissions_entity.modules.applications
        );
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;
        let url = `${appMasterApi.getApplicationv3}all${query}`;

        let userRole = this._lc.getUser();
        let currentUserRole: any = {};
        currentUserRole = userRole?.applicationAccess;

        //Find Application Access Rights
        const userAccess = Object.keys(currentUserRole).find(key => currentUserRole[key] === true);

        //Generate The URL Based On applicationAccess
        if (userAccess) {
            url = `${appMasterApi.getApplicationv3}${userAccess}${query}`
        }
       
        return this.httpClientService.get(
            `${url}`
        );
    }

    getArchivedApplication(pagination: PaginationType, filters?: any, sort: { sortDataOption: string, sortDataOrder: string } = null, archived?:boolean): Observable<any> {
        let query = '?';
        if (filters) {
            query += filters;
        }
        if (sort) { ///? for sorting
            query += `sortDataOption=${sort?.sortDataOption}&sortDataOrder=${sort?.sortDataOrder}&`;
        }
        if(archived){
            query+='archiveStatus=true&'
        }
        query += userParams.call(
            this,
            this.permissions_entity.modules.applications
        );
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;

        return this.httpClientService.get(
            `${appMasterApi.getArchiveApplication}${query}`
        );
    }

    getApplicationById(id: any): Observable<any> {
        return this.httpClientService.get(`${appMasterApi.getAppById}${id}`);
    }

    getNewMarksheet(payload: any): Observable<any> {
        let apiEndpoint = appMasterApi.postEnglishDetails; // 'v1/english/' previously

        // if (payload?.englishTest?.toLowerCase() === "ielts") {
        //     apiEndpoint += "ielts-verify";
        // } else if (payload?.englishTest?.toLowerCase() === "pte") {
        //     apiEndpoint += "pte-verify";
        // } else if (payload?.englishTest?.toLowerCase() === "toefl" || payload?.boardName?.toLowerCase() === "toefl ibt") {
        //     apiEndpoint += "toefl-verify";
        // }
    
        return this.httpClientService.post(apiEndpoint, payload);
    }

    postActivityLog(payload: any): Observable<any> {
        let apiEndpoint = appMasterApi.getactivitylog; //'v1/uel-pre-screening/add-to-queue'
        return this.httpClientService.postUELPrescreening(apiEndpoint, payload);
    }
    getUELPrescreening(camsId: any): Observable<any> {
        
        let apiEndpoint = appMasterApi.UELgetactivitylog; //'/v1/api/automationActivityLog?camsId='
        return this.httpClientService.get(`${apiEndpoint}${camsId}`);
    }

    createApplication(payload: any): Observable<any> {
        return this.httpClientService.post(
            appMasterApi.createApplication,
            payload
        );
    }

    updateApplication(appId: any, payload: any): Observable<any> {
        return this.httpClientService.put(
            `${appMasterApi.updateApplication}${appId}`,
            payload
        );
    }

    deleteApplication(id: any): Observable<any> {
        return this.httpClientService.delete(
            `${appMasterApi.deleteApplication}${id}`
        );
    }

    getUploadDoc(id: any, pagination: PaginationType) {
        return this.httpClientService.get(
            `${appMasterApi.getUploadDoc}${id}&skip=${pagination.skip}&limit=${pagination.limit}`
        );
    }

    createUploadDoc(payload: any): Observable<any> {
        return this.httpClientService.upload(
            appMasterApi.createUploadDoc,
            payload
        );
    }

    updateUploadDoc(appId: any, payload: any): Observable<any> {
        return this.httpClientService.put(
            `${appMasterApi.updateUploadDoc}${appId}`,
            payload
        );
    }

    deleteUploadDoc(id: any): Observable<any> {
        return this.httpClientService.delete(
            `${appMasterApi.deleteUploadDoc}${id}`
        );
    }

    getApplicationPrimaryStatus(universityCountryId?: any) {
        let query = '';
        if (universityCountryId) {
            query += `?universityCountryId=${universityCountryId}`;
        }
        return this.httpClientService.get(
            `${appMasterApi.primaryStatus}${query}`
        );
    }

    getApplicationPrimaryStatusupdate(universityCountryId?: any) {
        let query = '';
        if (universityCountryId) {
            query += `?universityCountryId=${universityCountryId}`;
        }
        return this.httpClientService.get(
            `${appMasterApi.primaryStatusupdate}${query}`
        );
    }

    getApplicationSecondaryStatus(id: any, universityCountryId?: string) {
        let query = ''
        if(universityCountryId){
            query += `&universityCountryId=${universityCountryId}`
        }
        return this.httpClientService.get(
            `${appMasterApi.secondaryStatus}${id}${query}&skip=0&limit=200`
        );
    }

    getApplicationHistory(id: any, pagination: PaginationType) {
        return this.httpClientService.get(
            `${appMasterApi.getApplicationHistory}/${id}?skip=${pagination.skip}&limit=${pagination.limit}`
        );
    }

    getApplicationHistoryComments(id: any, pagination: PaginationType) {
        return this.httpClientService.get(
            `${appMasterApi.getApplicationHistoryComments}${id}?skip=${pagination.skip}&limit=${pagination.limit}`
        );
    }

    createApplicationHistory(payload: any): Observable<any> {
        return this.httpClientService.post(
            appMasterApi.createApplicationHistory,
            payload
        );
    }

    createApplicationComment(payload: any): Observable<any> {
        return this.httpClientService.post(
            appMasterApi.createApplicationComment,
            payload
        );
    }
    createApplicationCommentV2(payload: any, params): Observable<any> {
        return this.httpClientService.upload(
            `${appMasterApi.createApplicationCommentV2}${params}`,
            payload
        );
    }

    updateApplicationHistory(appId: any, payload: any): Observable<any> {
        return this.httpClientService.put(
            `${appMasterApi.updateApplicationHistory}${appId}`,
            payload
        );
    }

    deleteApplicationHistory(id: any): Observable<any> {
        return this.httpClientService.delete(
            `${appMasterApi.deleteApplicationHistory}${id}`
        );
    }

    getPAQ() {
        return this.httpClientService.get(appMasterApi.getPAQ);
    }

    getPAQbyId(id: any) {
        return this.httpClientService.get(`${appMasterApi.getPAQbyId}${id}`);
    }

    createPAQ(payload: any): Observable<any> {
        return this.httpClientService.post(appMasterApi.createPAQ, payload);
    }

    updatePAQ(appId: any, payload: any): Observable<any> {
        return this.httpClientService.put(
            `${appMasterApi.updatePAQ}${appId}`,
            payload
        );
    }

    deletePAQ(id: any): Observable<any> {
        return this.httpClientService.delete(`${appMasterApi.deletePAQ}${id}`);
    }

    getAutoUpdateStatus() {
        return this.httpClientService.get(appMasterApi.getAutoUpdateStatus);
    }

    getBETemaComm() {
        return this.httpClientService.get(appMasterApi.getBETemaComm);
    }

    getBETemaCommAgent(pagination: PaginationType) {
        let query = '?';
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;
        return this.httpClientService.get(`${appMasterApi.getBETemaCommAgent}${query}`);
    }

    updateCourseEnrollment(
        enrollId: any,
        app_id: any,
        payload: any
    ): Observable<any> {
        return this.httpClientService.put(
            `${appMasterApi.updateCourseEnrollment}${enrollId}&applicationId=${app_id}`,
            payload
        );
    }

    getDuplicatePassport(id: any, passportId,currentApplicationId): Observable<any> {
        return this.httpClientService.get(
            `${appMasterApi.duplicatePassport}${id}&passportId=${passportId}&currentApplicationId=${currentApplicationId}`
        );
    }

    getDuplicatePhoneNumber(id: any): Observable<any> {
        return this.httpClientService.get(
            `${appMasterApi.duplicatePhoneNumber}${id}`
        );
    }

    getDuplicatePassportCount(id: any, passportId): Observable<any> {
        return this.httpClientService.get(
            `${appMasterApi.duplicatePassportCount}${id}&passportId=${passportId}`
        );
    }
     
    getDuplicatePassportCountV2(id: any, camsId): Observable<any> {
        return this.httpClientService.get(
            `${appMasterApi.duplicatePassportCountv2}${id}&camsId=${camsId}`
        );
    }

    getDuplicateNumberCount(id: any): Observable<any> {
        return this.httpClientService.get(
            `${appMasterApi.duplicatePhoneNumberCount}${id}`
        );
    }

    getMarksheet(payload: any): Observable<any> {
        let query = '';
        if (payload.year) {
            query += `&yearOfPassing=${payload.year}`;
        }
        return this.httpClientService.get(
            `${appMasterApi.getMarksheet}boardId=${payload.boardId}${query}`
        );
    }

    getPreviousQualification(pagination: any, search?: any): Observable<any> {
        let query = '?';
        if (search) {
            query += `search=${search}&`;
        }
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;
        return this.httpClientService.get(
            `${appMasterApi.previousQualification}${query}`
        );
    }

    baseURL: string = environment.apiURL;

    extractStudentData(
        pagination: PaginationType,
        filters?: any
    ): Observable<any> {
        let query = '?';
        if (filters) {
            query += filters;
        }
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;
        let url = `${appMasterApi.extractStudentData}all${query}`;
        
        let userRole = this._lc.getUser();
        let currentUserRole: any = {};
        currentUserRole = userRole?.applicationAccess;

        //Find Application Access Rights
        const userAccess = Object.keys(currentUserRole).find(key => currentUserRole[key] === true);

        //Generate The URL Based On applicationAccess
        if (userAccess) {
            url = `${appMasterApi.extractStudentData}${userAccess}${query}`
        }

        return this.httpClientService.csv(
            `${url}`
        );
    }

    adminExport(app_id: any) {
        return this.httpClientService.zip(
            `${appMasterApi.adminExport}${app_id}`
        );
    }

    getAppliedFilters() {
        let applied_filter = JSON.parse(
            localStorage.getItem('application_master_applied_filter') || '[]'
        );
        let applied_filter_count = applied_filter.length
            ? applied_filter.length
            : null;

        return { applied_filter, applied_filter_count };
    }

    copyPassport(masterId: any, app_id: any): Observable<any> {
        return this.httpClientService.put(
            `${appMasterApi.copyPassport}${masterId}&applicationId=${app_id}`,
            {}
        );
    }

    globalSearch(pagination: PaginationType, search?: any): Observable<any> {
        let query = '?';
        let permissions = JSON.parse(localStorage.getItem('roles_permissions'))?.[0]?.permission;
        let hasP= permissions?.find((item) => item?.module === 'Archived');
        if (search) {
            query += `search=${search}&`;
        }
        // query += userParams.call(this, this.permissions_entity.modules.applications);
        query += `skip=${pagination.skip}&limit=${pagination.limit}${hasP?'&archive=true':''}`;
        return this.httpClientService.get(
            `${appMasterApi.globalSearch}${query}`
        );
    }

    toggleUpdateUploadDoc(
        appId: any,
        docId: string = '',
        payload: any
    ): Observable<any> {
        return this.httpClientService.put(
            `${appMasterApi.toggleUpdateUploadDoc}?applicationId=${appId}&id=${docId}`,
            payload
        );
    }

    phpGetApplicationFiles(userId, camsId): Observable<any> {
        return this.httpClientService.getPhpV2(
            `${appMasterApi.phpGetApplicationFiles}?user_id=${userId}&order_id=${camsId}`,
        );
    }

    phpGetApplicationComments(userId, camsId): Observable<any> {
        return this.httpClientService.getPhpV2(
            `${appMasterApi.phpGetApplicationComments}?user_id=${userId}&order_id=${camsId}`,
        );
    }

    phpGetApplicationMails(userId, camsId): Observable<any> {
        return this.httpClientService.getPhpV2(
            `${appMasterApi.phpGetApplicationMails}?user_id=${userId}&order_id=${camsId}`,
        );
    }
    phpGetApplicationOrder(userId, camsId): Observable<any> {
        return this.httpClientService.getPhpV2(
            `${appMasterApi.phpGetApplicationOrder}?user_id=${userId}&order_id=${camsId}`,
        );
    }

    phpGetApplicationOrderStatus(userId, camsId): Observable<any> {
        return this.httpClientService.getPhpV2(
            `${appMasterApi.phpGetApplicationOrdeStatus}?user_id=${userId}&order_id=${camsId}`,
        );
    }

    phpGetCommission(manufactureId, intakeName, destinationCountryId, universityCountryId): Observable<any> {
        return this.httpClientService.getPhpV2(
            `${appMasterApi.phpGetCommission}?storeId=1&skip=0&limit=10&manufactureId=${manufactureId}&intakeName=${intakeName}&studentCountryId=${destinationCountryId}&universityCountryId=${universityCountryId}`,
        );
    }

    getreAssignUser(pagination: any, tenantId?: any, universityId?: any, usertype: any = "CAT"): Observable<any> {
        let query = '?';
        if (tenantId) {
            query += `tenantId=${tenantId}&`;
        }
        if (universityId) {
            query += `universityId=${universityId}&`;
        }
        if (usertype) {
            query += `usertype=${usertype}&`;
        }
        query += `skip=${pagination.skip}&limit=${pagination.limit}`;
        return this.httpClientService.get(
            `${appMasterApi.getreAssignUser}${query}`
        );
    }
    offerBNUcommend(
        name: any,
        from: any,
        domain: any,
        tenantId: any,
        agentCommunicationStatusId: any,
        agentCommunicationStatus: any,
        payload: any,
    ): Observable<any> {
        let query = '?';
        if (name) {
            query += `name=${name}&`;
        }
        if (from) {
            query += `from=${from}&`;
        }
        if (domain) {
            query += `domain=${domain}&`;
        }
        if (tenantId) {
            query += `tenantId=${tenantId}&`;
        }
        if (agentCommunicationStatusId) {
            query += `agentCommunicationStatusId=${agentCommunicationStatusId}&`;
        }
        if (agentCommunicationStatus) {
            query += `agentCommunicationStatus=${agentCommunicationStatus}`;
        }
        return this.httpClientService.upload(
            `${appMasterApi.createApplicationCommentV2}${query}`,
            payload
        );
    }

    instantApply(payload: any): Observable<any> {
        return this.httpClientService.post(`${appMasterApi.instantApply}`, payload);
    }

    instantApplyAdmin(payload: any): Observable<any> {
        return this.httpClientService.post(`${appMasterApi.instantApplyAdmin}`, payload);
    }

    
  getUploadDocuments(pagination: PaginationType, id: any): Observable<any> {
    let query = `skip=${pagination.skip}&limit=${pagination.limit}`;
    return this.httpClientService.get(`${appMasterApi.getUploadDocuments}${id}&internalStatus=true&${query}`);
  }

  getTracker(pagination: PaginationType, id: any): Observable<any> {
    let query = `skip=${pagination.skip}&limit=${pagination.limit}`;
    return this.httpClientService.csv(`${appMasterApi.getTrackerData}?intake=${id}&preOffer=true&${query}`);
  }
  postOffreLetterCondition(payload) : Observable<any> {
    return this.httpClientService.postcondition(`${appMasterApi.offerConditionpost}`,payload);
  }
  conditionUpdate(payload: any): Observable<any>{
    return this.httpClientService.putcondition(`${appMasterApi.offerConditionpost}`,payload);
  }
  getDataCondition(applicationId: any, universityId: any): Observable<any> {
    return this.httpClientService.getcondition(
        `${appMasterApi.offerConditionpost}?applicationId=${applicationId}&universityId=${universityId}`
    );
}
    getCabin( ){
        return this.httpClientService.getPhp(`${appMasterApi.getCabin}`);
    }
    getSeatByCabinId(cabin_id:any): Observable<any> {
        return this.httpClientService.getPhp(`${appMasterApi.getSeatByCabinId}${cabin_id}`);
    }

initiateCall(payload: any): Observable<any> {  
    return this.httpClientService.post(appMasterApi.initiateCall, payload);  
  }
  
    botToggle(payload: any): Observable<any> {  
        return this.httpClientService.post(appMasterApi.botToggle, payload);  
    }

  compressFile(payload: any): Observable<any> {
    return this.httpClientService.get(appMasterApi.compressFile.replace(':appID',payload.applicationId).replace(':docID',payload.docId));  
  }
  downloadFileUpload(id,payload: any): Observable<any>{
    return this.httpClientService.upload(`${appMasterApi.downloadFileUpload}${id}`, payload); 
  }

  getAppQuestions(id: any): Observable<any> {
    return this.httpClientService.get(`${appMasterApi.getAppQuestions}${id}`);
  }
  adminMaskInfo(id: any,payload: any): Observable<any> {  
    return this.httpClientService.post(`${appMasterApi.getByIdAdminMaskInfo}/${id}`, payload);  
  }
  unmaskDetailsForOffer(id: any,payload: any): Observable<any> {
    return this.httpClientService.post(`${appMasterApi.unMaskDetails}/${id}`,payload);
  }
  adminUnMaskInfo(id: any,payload: any): Observable<any> {  
    return this.httpClientService.post(`${appMasterApi.getByIdAdminUnMaskInfo}/${id}`, payload);  
  }

  preSessionalApply(payload: any): Observable<any> {
    return this.httpClientService.post(`${appMasterApi.preSessionalApply}`, payload);
  }

  saveApprovalStatus(id: any, payload: any): Observable<any> {
    return this.httpClientService.post(`${appMasterApi.saveApprovalStatus}${id}`, payload);
  }

  updateImportantInternal(id: any, markAsImportant,text): Observable<any> {
    return this.httpClientService.post(`${appMasterApi.updateImportant}${'?id='+id}${'&isImportantInternal='+markAsImportant}${'&comment='+text}`,{});
  }

  updateImportantExternal(id: any, markAsImportant): Observable<any> {
    return this.httpClientService.post(`${appMasterApi.updateImportant}${'?id='+id}${'&isImportantExternal='+markAsImportant}`,{});
  }
  verifyTwoFactorCode(id: any){
    return this.httpClientService.post(`${appMasterApi.getTwofactor}${id}`,{})
  }
  
}
